import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuPortal,
} from "~/components/shared/DropdownMenu";
import Icon from "~/components/shared/Icon";
import { useBuildPreferencesStore } from "~/components/build/Show/lib/useBuildPreferencesStore";

export function TableActionsDropdown() {
  const resetColumnWidths = useBuildPreferencesStore((state) => state.resetColumnWidths);

  return (
    <div className="flex w-full justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger asChild={true}>
          <button className="flex items-center rounded-md p-0.5 hover:bg-purple-100 hover:text-purple-600">
            <Icon icon="heroicons/solid/ellipsis-vertical" className="h-5 w-5" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuPortal>
          <DropdownMenuContent>
            <button
              className="text-charcoal-600 flex max-w-full items-center self-center truncate rounded-md px-2 py-1 font-normal transition-colors hover:border-gray-300 hover:bg-gray-200"
              onClick={resetColumnWidths}
            >
              <span>Reset all column widths</span>
            </button>
          </DropdownMenuContent>
        </DropdownMenuPortal>
      </DropdownMenu>
    </div>
  );
}
